import {
  Grid, TextField,
} from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import * as React from 'react';
import deselectElementPreventDefaultAndBlur from '../../lib/deselectAndBlur';
import useEventListener from '../../lib/useEventListener';

import WorkReassignmentDropoff from './workReassignmentDropoff';

const WorkReassignmentLandingPage: React.FC = () => {
  const [showReassignmentInterface, setShowReassignmentInterface] = React.useState<boolean>(false);
  const [initialBarcodeValue, setInitialBarcodeValue] = React.useState<string>();

  let bannerBuffer = '';
  const handleBannerScannerInput = (e: KeyboardEvent) => {
    if (e.key && (e.key !== 'Shift')) {
      bannerBuffer = `${bannerBuffer}${e.key}`;

      if (bannerBuffer.toLowerCase().includes('in:')) {
        bannerBuffer = '';
      }
      if (bannerBuffer.includes('{*|}')) {
        deselectElementPreventDefaultAndBlur(e);
        if (!showReassignmentInterface) {
          setInitialBarcodeValue(bannerBuffer.replace('{*|}', ''));
          setShowReassignmentInterface(true);
          bannerBuffer = '';
        }
      }
    }
  };

  let honeywellBuffer = '';
  const handleHoneywellInput = (e: KeyboardEvent) => {
    if (e.key && (e.key.length === 1 || e.key === 'Enter')) {
      if (e.key !== 'Enter') {
        honeywellBuffer = `${honeywellBuffer}${e.key}`;
      } else {
        if (!e.defaultPrevented) {
          if (!showReassignmentInterface) {
            honeywellBuffer.replace('{*|}', '');
            setInitialBarcodeValue(honeywellBuffer.replace('{*|}', ''));
            setShowReassignmentInterface(true);
            honeywellBuffer = '';
          }
        }
        honeywellBuffer = '';
      }
    }
  };

  useEventListener('keydown', handleBannerScannerInput);
  useEventListener('keydown', handleHoneywellInput);

  return (
    <Grid container spacing={0}>
      {(showReassignmentInterface && initialBarcodeValue)
        ? (
          <>
            <WorkReassignmentDropoff initialBarcode={initialBarcodeValue} setShowReassignmentInterface={setShowReassignmentInterface} showReassignmentInterface={showReassignmentInterface} />
          </>
        )
        : (
          <>
            <Grid container direction="column" spacing={2} alignItems="center" justifyContent="center">
              <Grid item>
                <Alert severity="info">{'Scan in repair to reassignment process.'}</Alert>
              </Grid>
              <Grid item>
                <TextField
                  id="courier-input"
                  variant="outlined"
                  size="small"
                  onChange={
                    (event) => {
                      // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                      setInitialBarcodeValue((event.target as HTMLInputElement).value);
                    }
                  }
                  onKeyPress={
                      (event) => {
                        if (event.key === 'Enter') {
                          event.preventDefault();
                          event.stopPropagation();
                          // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                          setInitialBarcodeValue((event.target as HTMLInputElement).value);
                          setShowReassignmentInterface(true);
                        } else {
                          setShowReassignmentInterface(false);
                        }
                      }
                    }
                />
              </Grid>
            </Grid>
          </>
        )}
    </Grid>
  );
};

export default WorkReassignmentLandingPage;
